'use strict';

/* Self contained scripts */
import 'vendor';

import React from 'react';

import { io, http, mq, config, history, ReactAddons, render, log, dropperl, fromJS } from 'core';

import { Mobile } from 'routes';

import 'bind';

import initializeTouchTap from "react-tap-event-plugin";

initializeTouchTap();

const target = process.env.TARGET;

/* Exposing to Browser
 *  window: env -> dev */
(w => {
    w.app_build = target;
    w._ = _;
    w.$ = $;
    w.jQuery = $;
    w.http = http;
    w.React = React;
    w.Promise = Promise;
    w.$get = url => http.get(url).then( response => console.log(response) );
    w.$post = (url, data) => http.post(url, data).then( response => console.log(response) );
})(window);

log.bold(`build:${target.toLowerCase()}`);

/* Starts application,
 *  routes:routes
 *  -> router:react-router
 *  -> handler:components/index
 *  -> component:components/ ... */

/* No dependencies here! */
(function appReady() {

    render(Mobile, document.getElementsByTagName('react')[0]);
    io.on('app:mounted', () => { });
})();

let queue = [];
let map = {};
let sum = 0;

async function consumeQueue() {

    const current = queue.pop();

    if (current === undefined) return getMeasure();

    return true;

    sum += map[current];

    return true;
}

let { drop: startDrop, dropping } = dropperl({
    fn: consumeQueue,
    continueAfterCall: true
});

function other() {

    work: while (true) {

        const current = queue.shift();

        try {

            sum += map[current].v;

        } catch (e) {

            break work;
        }
    };

    return getMeasure();
}

function getMeasure() {

    const broke = window.performance.now();

    console.log((broke - before).toFixed(2), (broke - after).toFixed(2), sum);
}

function push(...items) {

    items.forEach((v, i) => {

        queue.push(i);
        map[i] = { v };
    });
}

var before, after;



// WEBPACK FOOTER //
// ./app/index.jsx